import {Translate} from 'react-redux-i18n';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {Icon} from 'front-onceforall-core';
import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';
import {useHistory} from 'react-router-dom';
import * as snackbarsActions from '../../actions/snackbars';
import documentService from '../../services/document/DocumentService';
import {ProjectDossierStatsContext} from '../../views/projectDetails/ProjectDetailsView';
import {captureError} from '../../utils/log';
import config from '../../../config';
import constructDataElement from '../documentsStats/utils/constructDataElement';
import DocumentsStats from '../documentsStats';

function ProjectStatsDocuments({myIntervention}) {
  const [user, currentLocale] = useSelector(state => [
    state.user,
    state.i18n.locale
  ]);
  const dispatch = useDispatch();
  const history = useHistory();

  function handleDownloadProjectStatus() {
    const data = {
      userId: user.id,
      interventionId: myIntervention.interventionId,
      locale: currentLocale
    };

    documentService.createDocumentExport(data)
      .then(() => dispatch(snackbarsActions.addSuccess(<Translate value="message.exportRequestSuccess"/>)))
      .catch(error => {
        captureError('documentService.createDocumentExport', error);
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      });
  }

  const getData = (percentages = {}) => ([
    constructDataElement(percentages[DOCUMENT_STATE.VALID], '#3fd2b0', 'project.documentsStates.VALID', true),
    constructDataElement(percentages[DOCUMENT_STATE.ALMOST_EXPIRED], '#ecc430', 'project.documentsStates.ALMOST_EXPIRED', true),
    constructDataElement(percentages[DOCUMENT_STATE.MISSING], '#fb3958', 'project.documentsStates.MISSING', false)
  ]);

  const actions = (
    <>
      <button
        type="button"
        className="large secondary flex-container"
        onClick={handleDownloadProjectStatus}
      >
        <Icon icon="folder-download"/>
        <Translate value="project.exportDossier"/>
      </button>
      {config.featureFlags.invalidDocuments &&
        <button
          type="button"
          className="large secondary flex-container mt-3"
          onClick={() => history.push(`/project/${myIntervention.project.projectId}/intervention/${myIntervention.interventionId}/invalid-organisation-documents`)}
        >
          <Icon icon="document"/>
          <Translate value="project.showInvalidDocumentsPage"/>
        </button>
      }
    </>
  );

  return (
    <ProjectDossierStatsContext.Consumer>
      {value => (
        <DocumentsStats
          data={getData(value.projectDossierStatesDocuments.percentage)}
          loading={value.projectDossierStatesDocuments.loading}
          error={value.projectDossierStatesDocuments.error}
          actions={actions}
          title="project.documents"
        />
      )}
    </ProjectDossierStatsContext.Consumer>
  );
}

ProjectStatsDocuments.propTypes = {
  myIntervention: PropTypes.object.isRequired
};

export default ProjectStatsDocuments;
